import { ReactElement, useState } from "react";


interface ICollapsible{
    children: ReactElement,
    isCollapsed: boolean
}

export default function Collapsible({children, isCollapsed} : ICollapsible){
    
    return(<div className={`collapsible ${isCollapsed ? "collapsible--collapsed" : ""}`}>
        {children}
    </div>)
}